import { useCustomValueTags } from "PFApp/hooks/use_custom_value_tags";
import { useExperienceConfig } from "PFApp/hooks/use_experience_config";
import { useExperienceLabelMap } from "PFApp/hooks/use_experience_label_map";
import { Stack } from "PFComponents/containers";
import { CustomValuePill } from "PFComponents/custom_value_pill";
import { Typography } from "PFComponents/typography";
import { Experience, Id, SkillsFramework } from "PFCore/types";
import { useTranslation } from "react-i18next";

type FrameworkValueTooltipProps = {
  name: string;
  requiredExperience?: Experience;
  frameworks: Pick<SkillsFramework, "id" | "name" | "rank">[];
  tagIds?: Id[];
};

const TooltipFrameworkElement = ({ frameworks }: Pick<FrameworkValueTooltipProps, "frameworks">) => {
  const { t } = useTranslation("activities", { keyPrefix: "form.sections.skillsFrameworks.sidePanel" });

  return (
    <Stack alignItems="center">
      <Typography variant="labelRegular">{t("skillsFramework")}</Typography>
      {frameworks.map((framework) => (
        <Stack key={framework.id} alignItems="center" gap={null}>
          <Typography variant="labelBold">{framework.name}</Typography>
          <Typography variant="labelRegular">
            ({t(framework.rank as unknown as TemplateStringsArray)})
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export const FrameworkValueTooltip = ({
  name,
  requiredExperience,
  frameworks,
  tagIds = []
}: FrameworkValueTooltipProps) => {
  const { experienceLevels } = useExperienceConfig();
  const experienceLabelMap = useExperienceLabelMap();
  const { getCustomValueTags } = useCustomValueTags();

  return (
    <CustomValuePill
      name={name}
      requiredExperience={requiredExperience}
      experienceLevels={experienceLevels}
      experienceLabelMap={experienceLabelMap}
      tags={getCustomValueTags(tagIds)}
      customTooltipElement={<TooltipFrameworkElement frameworks={frameworks} />}
      isRequirement
    />
  );
};
